import * as React from 'react';
import { createComponent } from '@lit/react';
import { SegmentedControlItemWC } from './segmented-control-item.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type SegmentedControlItemProps =
  GenerateComponentTypeWithChildren<SegmentedControlItemWC>;

export type SegmentedControlItemPropsWithRef =
  GeneratePropsWithRef<SegmentedControlItemProps>;

export const SegmentedControlItem = createComponent({
  tagName: SegmentedControlItemWC.tagname,
  elementClass: SegmentedControlItemWC,
  react: React,
}) as SegmentedControlItemPropsWithRef;
